import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

export interface PublicApiInfo {
  key: string;

  source: "database" | "env";
  api_url: string;
  snippet: string;
}

export interface WebsiteSite {
  id: string;
  name: string;
  origin: string;
  is_active: string;
  created_at: string;
}

@Injectable({ providedIn: "root" })
export class WebsiteSettingsService {
  private http = inject(HttpClient);

  private base = `${environment.baseUrl}/settings`;

  getPublicApi(): Observable<PublicApiInfo> {
    return this.http.get<PublicApiInfo>(`${this.base}/public_api`);
  }

  rotatePublicApi(): Observable<PublicApiInfo> {
    return this.http.post<PublicApiInfo>(`${this.base}/public_api/rotate`, {});
  }

  getSites(): Observable<{ sites: WebsiteSite[] }> {
    return this.http.get<{ sites: WebsiteSite[] }>(`${this.base}/sites`);
  }

  addSite(site: { origin: string; name: string }): Observable<{ sites: WebsiteSite[] }> {
    return this.http.post<{ sites: WebsiteSite[] }>(`${this.base}/sites`, site);
  }

  deleteSite(id: string): Observable<{ sites: WebsiteSite[] }> {
    return this.http.delete<{ sites: WebsiteSite[] }>(`${this.base}/sites/${id}`);
  }
}
